<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      :before-close="resetValidation('label')"
      @close="setDialog(false)"
    >
      <el-form ref="label" id="label-form" :model="label" label-position="top">
        <el-form-item
          label="Name"
          ref="name"
          prop="name"
          required
          :rules="[{ required: true, message: 'name is required' }]"
        >
          <el-input type="text" v-model="label.name" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
  computed: {
    dialogTitle: function() {
      if (this.label.id !== null) return 'Edit Label'
      else {
        return 'Insert Label'
      }
    },
    ...mapState('newReleasesLabels', ['loading', 'label', 'dialog'])
  },

  methods: {
    ...mapActions('newReleasesLabels', ['update', 'insert', 'createLabel']),
    ...mapMutations('newReleasesLabels', ['setSelectedLabel', 'setDialog']),
    ...mapMutations('global', ['setPreview']),

    submit() {
      if (this.label.id !== null) {
        this.update(this.label)
        //this.setDialog(false)
      } else {
        this.createLabel(this.label.name)
        this.label.name = "";
        //this.setDialog(false)
      }
    },

    resetValidation(formName) {
      if (typeof this.$refs[formName] != 'undefined') {
        this.$refs[formName].fields.find(f => f.prop == 'name').clearValidate()
      }
    }
  }
}
</script>
